import React from "react";
import { FooterContainer, StyledLink } from "./Footer.styled";

const MENUS = [
  {
    name: "Home",
    link: "/",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.7621 0.318666C11.9932 0.11338 12.2917 0 12.6008 0C12.91 0 13.2084 0.11338 13.4396 0.318666L24.8085 10.4243C25.0461 10.6501 25.1867 10.9594 25.2005 11.2869C25.2144 11.6144 25.1003 11.9344 24.8826 12.1794C24.6648 12.4244 24.3603 12.5751 24.0335 12.5998C23.7066 12.6245 23.383 12.5211 23.1309 12.3115L22.7065 11.9364V21.4736C22.7065 22.1436 22.4403 22.7862 21.9665 23.26C21.4927 23.7338 20.8501 24 20.1801 24H5.02159C4.35154 24 3.70894 23.7338 3.23514 23.26C2.76135 22.7862 2.49517 22.1436 2.49517 21.4736V11.9364L2.07073 12.3115C1.81867 12.5211 1.49503 12.6245 1.16817 12.5998C0.841317 12.5751 0.536844 12.4244 0.319075 12.1794C0.101307 11.9344 -0.0127048 11.6144 0.00112608 11.2869C0.0149569 10.9594 0.155547 10.6501 0.393197 10.4243L11.7621 0.318666ZM5.02159 9.68787V21.4736H8.81121V15.1576C8.81121 14.8225 8.94429 14.5012 9.18119 14.2643C9.41809 14.0274 9.73939 13.8943 10.0744 13.8943H15.1272C15.4623 13.8943 15.7836 14.0274 16.0205 14.2643C16.2574 14.5012 16.3904 14.8225 16.3904 15.1576V21.4736H20.1801V9.68913L12.6008 2.95245L5.02159 9.68787ZM13.864 21.4736V16.4208H11.3376V21.4736H13.864Z" />
      </svg>
    ),
  },
  {
    name: "Investment",
    link: "/investment",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 1V23"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Earn",
    link: "/earn",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V6C21 4.89543 20.1046 4 19 4Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 2V6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8 2V6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3 10H21"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Staking",
    link: "staking",
    icon: (
      <svg
        width="20"
        height="22"
        viewBox="0 0 20 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.75 3V21H12.25V3C12.25 1.9 11.8 1 10.45 1H9.55C8.2 1 7.75 1.9 7.75 3ZM1 9V21H5V9C5 7.9 4.6 7 3.4 7H2.6C1.4 7 1 7.9 1 9ZM15 14V21H19V14C19 12.9 18.6 12 17.4 12H16.6C15.4 12 15 12.9 15 14Z"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Profile",
    link: "profile",
    icon: (
      <svg
        width="20"
        height="24"
        viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.64 15.1C16.64 12.7 14.74 10.9 12.44 10C13.74 9.00003 14.54 7.40003 14.54 5.7C14.54 2.5 12.04 0 8.94 0C5.84 0 3.34 2.5 3.34 5.6C3.34 7.30003 4.14 8.90003 5.44 9.90003C3.14 10.8 1.24 12.6 0.24 15C-0.16 16 -0.0600001 17.2 0.54 18.1C1.14 19.1 2.24 19.6 3.44 19.6H14.54C15.74 19.6 16.74 19 17.44 18.1C18.04 17.2 18.14 16.1 17.64 15.1Z" />
      </svg>
    ),
  },
];

const Footer = () => {
  return (
    <FooterContainer id="footer">
      {MENUS.map((menu, index) => (
        <StyledLink to={menu.link} key={index} activeclassname="active">
          {menu.icon}
          {menu.name}
        </StyledLink>
      ))}
    </FooterContainer>
  );
};

export default Footer;
